import React, { Component } from 'react';
import { parse } from 'qs';
import UsersService from '../../../services/UsersService';
import { appPath } from '../../../constants';

export default function notificationHOC (ConversationsListContainer) {
  return class FromNotification extends Component {
    render () {
      const { convId } = parse(window.location.search, { ignoreQueryPrefix: true });
      if (convId) {
        if (UsersService.isAdmin()) {
          window.close();
          window.open(`/${appPath}/conversation/${convId}`, '_blank', 'height=700, width=500');
          return null;
        } else {
          return <ConversationsListContainer {...this.props} convIdfromNotification={parseInt(convId, 10)} />;
        }
      }

      return <ConversationsListContainer {...this.props} />;
    }
  };
}



// WEBPACK FOOTER //
// ./src/components/app/messages/notificationHOC.js